module.exports = __webpack_public_path__ + "img/padres.82d64871.svg";